export default "__VITE_ASSET__BGxGLFjW__"